import { createReducer, on } from '@ngrx/store';
import { setNamingConvention } from './naming-convention.actions';
import { ReportNamingConvention } from '../../enums/naming-convention.enum';
export const namingConvention = createReducer(ReportNamingConvention.TRUNCATED, on(setNamingConvention, (state, action) => {
    return action.namingConvention;
}));
